import { render, staticRenderFns } from "./giveCouponFromList.vue?vue&type=template&id=370dd89e"
import script from "./giveCouponFromList.vue?vue&type=script&lang=js"
export * from "./giveCouponFromList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports